"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var coordinate_1 = require("./coordinate");
/**
 * 极坐标系
 * @since 2.0
 *
 * @todo 支持多轴
 */
var PolarCoordinate = /** @class */ (function (_super) {
    tslib_1.__extends(PolarCoordinate, _super);
    function PolarCoordinate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarCoordinate.prototype.draw = function () {
        var _a = this.ctx.theme.padding, left = _a.left, top = _a.top;
        var align = this.ctx.getOption("legend").align;
        var backgroundHeight = parseInt(this.ctx.background.attr("height"), 10);
        this.width = parseInt(this.ctx.background.attr("width"), 10);
        // 24 = x轴标签高度（font-size） + 10
        this.height = backgroundHeight;
        if (align === "bottom") {
            this.height -= this.helpers.legend.height + 20;
        }
        else if (align === "right") {
            this.width -= this.helpers.legend.width + 20;
        }
        // 更新绘图区背景
        this.ctx.plotBackgound
            .attr("x", 0)
            .attr("y", 0)
            .attr("height", this.height)
            .attr("width", this.width);
        this.ctx.plotMask
            .attr("x", left - 5)
            .attr("y", top - 5)
            .attr("height", this.height + 5)
            .attr("width", this.width + 10);
    };
    return PolarCoordinate;
}(coordinate_1.Coordinate));
exports.PolarCoordinate = PolarCoordinate;
//# sourceMappingURL=polar-coord.js.map